import { GET_NEW_TOKEN } from "../actions/new-token-action";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
    loading: false,
    data: [],
    error: null,
};

const newTokenReducer = (
    state = initialState,
    action: any
): ApiRequestState => {
    switch (action.type) {
        case GET_NEW_TOKEN.REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_NEW_TOKEN.SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };
        case GET_NEW_TOKEN.FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export { newTokenReducer };